import React, { useRef, useEffect } from 'react';
import Slider from 'react-slick';

// Advisor Card Component
const AdvisorCard = ({ topBar, title, content, button, setCompanyDashboardTab, index }) => {
    return (
        <div className="advisor-carousel-slide" style={{ minHeight: '240px' }}>
            <div className="br20px bg1 shadow p1rem" style={{ height: '100%', display: 'flex', flexDirection: 'column', minHeight: '240px' }}>
                <div className="df fdc aic" style={{ gap: '1rem', height: '100%', alignItems: 'center' }}>
                    {/* Top Bar - Button or Image */}
                    {
                        topBar?.type === 'button' || topBar?.type === 'image' ? <div className='df aic jcc' style={{ height: '60px' }}>
                            {topBar?.type === 'button' && topBar?.text && (
                                <div className="bg38 br20px px1rem py0-5rem" style={{ backgroundColor: '#E8F5E9', borderRadius: '20px', width: 'fit-content' }}>
                                    <span className="c59 fw600 fs1-25rem">{topBar.text}</span>
                                </div>
                            )}
                            {topBar?.type === 'image' && topBar?.imageUrl && (
                                <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <img
                                        src={topBar.imageUrl}
                                        alt={title || 'Advisor'}
                                        className="br20ox ofc"
                                        style={{
                                            maxWidth: '100%',
                                            height: 'auto'
                                        }}
                                    />
                                </div>
                            )}
                        </div> : null
                    }

                    {/* Title */}
                    {
                        title || content ? (
                            <div className="df fdc aic" style={{ height: '60px' }}>
                                {title && (
                                    <p className="fs1rem tac" style={{ color: '#FC7785', fontWeight: 600, textAlign: 'center' }}>{title}</p>
                                )}
                                {content && (
                                    <p className="fs1rem tac" style={{ color: '#5E5F66', fontSize: !title ? '1rem' : '0.75rem', flex: 1, textAlign: 'center' }}>{content}</p>
                                )}
                            </div>
                        ) : null
                    }

                    {/* Bottom Button */}
                    {button?.text && index !== 0 && (
                        <button
                            className="br20px px1-5rem py0-75rem c1 fw500 cp"
                            style={{
                                backgroundColor: '#F78B9B',
                                border: 'none',
                                borderRadius: '20px',
                                color: '#fff',
                                fontSize: '0.875rem',
                                width: 'fit-content',
                                cursor: 'pointer'
                            }}
                            onClick={() => {
                                if (button?.link) {
                                    // If link is '#', navigate to InvestorMatch tab
                                    if (button.link === '#') {
                                        // setCompanyDashboardTab?.('InvestorMatch');
                                    } else {
                                        // For external links, open in new tab
                                        window.open(button.link, '_blank', 'noopener,noreferrer');
                                    }
                                }
                            }}
                        >
                            {button.text}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

// Advisor Carousel Data
const advisorCarouselData = [
    {
        id: 1,
        topBar: {
            type: 'button',
            text: 'PRO Plus'
        },
        title: 'Can’t or don’t want to DIY?',
        content: 'Be matched to an individual advisor or one of our specialist partner organsiations',
        button: {
            text: 'Book A Call',
            link: 'https://koalendar.com/e/meet-with-mark-bernstein'
        }
    },
    {
        id: 2,
        topBar: {
            type: 'image',
            imageUrl: require('../../../../../../images/dashboard/advisorMatchIcon.png')
        },
        title: 'AdvisorMatch',
        content: 'Get help from one of our CFOs',
        button: {
            text: 'Book A Call',
            link: 'https://koalendar.com/e/meet-with-mark-bernstein'
        }
    },
    {
        id: 3,
        topBar: {
            type: 'image',
            imageUrl: require('../../../../../../images/dashboard/03.png')
        },
        title: 'Get help from an experienced C-suite expert',
        content: 'Multi-discipline',
        button: {
            text: 'Book A Call',
            link: 'https://koalendar.com/e/meet-with-mark-bernstein'
        }
    },
    {
        id: 4,
        topBar: {
            type: 'image',
            imageUrl: require('../../../../../../images/dashboard/04.png')
        },
        title: <>Get help from an experienced <br /> CFO</>,
        content: 'Fixed price 4 quarterly reviews',
        button: {
            text: 'Book A Call',
            link: 'https://koalendar.com/e/meet-with-mark-bernstein'
        }
    },
    {
        id: 5,
        topBar: {
            type: 'image',
            imageUrl: require('../../../../../../images/dashboard/05.png')
        },
        title: 'Get help from investment readiness specialist',
        content: 'St. John’s Innovation Centre',
        button: {
            text: 'Book A Call',
            link: 'https://koalendar.com/e/meet-with-mark-bernstein'
        }
    },
    {
        id: 6,
        topBar: {
            type: 'image',
            imageUrl: require('../../../../../../images/dashboard/06.png')
        },
        title: 'Get help from business growth specialist',
        content: 'North East Innovation Accelerator',
        button: {
            text: 'Book A Call',
            link: 'https://koalendar.com/e/meet-with-mark-bernstein'
        }
    }
];

const AdvisorCarousel = ({ setCompanyDashboardTab }) => {
    const advisorCarouselRef = useRef(null);
    const wrapperRef = useRef(null);

    useEffect(() => {
        // Force slick to recalculate dimensions after mount or when items change
        if (advisorCarouselRef.current && wrapperRef.current) {
            const recalculate = () => {
                if (advisorCarouselRef.current) {
                    advisorCarouselRef.current.slickGoTo(0, true);
                }
            };

            // Initial recalculation
            const timer1 = setTimeout(() => {
                if (advisorCarouselRef.current) {
                    advisorCarouselRef.current.slickGoTo(0, true);
                }
            }, 50);

            const timer2 = setTimeout(() => {
                if (advisorCarouselRef.current) {
                    advisorCarouselRef.current.slickGoTo(0, true);
                }
            }, 200);

            // Handle window resize
            window.addEventListener('resize', recalculate);

            return () => {
                clearTimeout(timer1);
                clearTimeout(timer2);
                window.removeEventListener('resize', recalculate);
            };
        }
    }, [advisorCarouselData]);

    // Group items into slides of 6 (2 rows x 3 columns)
    const groupedItems = [];
    for (let i = 0; i < advisorCarouselData.length; i += 6) {
        groupedItems.push(advisorCarouselData.slice(i, i + 6));
    }

    return (
        <div
            ref={wrapperRef}
            className="advisor-carousel-wrapper"
            style={{
                width: '100%',
                maxWidth: '100%',
                position: 'relative',
                isolation: 'isolate',
                overflow: 'hidden'
            }}
        >
            <Slider
                className="advisor-carousel-slider"
                ref={advisorCarouselRef}
                infinite={groupedItems.length > 1}
                speed={500}
                slidesToShow={1}
                slidesToScroll={1}
                autoplay={false}
                arrows={false}
                dots={true}
                adaptiveHeight={false}
                variableWidth={false}
                customPaging={(i) => (
                    <div className="advisor-carousel-dot">
                        <span className="advisor-carousel-dot-number">{i + 1}</span>
                    </div>
                )}
                appendDots={(dots) => (
                    <ul className="advisor-carousel-dots" style={{ margin: '0px', padding: '0px', listStyle: 'none' }}>
                        {dots}
                    </ul>
                )}
            >
                {groupedItems.map((slideItems, slideIndex) => (
                    <div key={slideIndex} className="advisor-carousel-slide">
                        <div className="advisor-carousel-slide-content">
                            <div className="dg advisor-carousel-grid" style={{ width: '100%', gridTemplateColumns: 'repeat(3, 1fr)', boxSizing: 'border-box', rowGap: '1rem', columnGap: '0rem' }}>
                                {slideItems.map((card, itemIndex) => (
                                    <div key={card.id || itemIndex} className="advisor-carousel-item" style={{ width: '100%', minWidth: 0, boxSizing: 'border-box' }}>
                                        <AdvisorCard
                                            topBar={card.topBar}
                                            title={card.title}
                                            content={card.content}
                                            button={card.button}
                                            setCompanyDashboardTab={setCompanyDashboardTab}
                                            index={itemIndex}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                ))}
            </Slider>
            {/* Custom Navigation Buttons */}
            <button
                className="advisor-carousel-nav advisor-carousel-prev bg3 br100 df jcc aic cp"
                onClick={() => advisorCarouselRef.current?.slickPrev()}
                aria-label="Previous slide"
            >
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.5 15L7.5 10L12.5 5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </button>
            <button
                className="advisor-carousel-nav advisor-carousel-next bg3 br100 df jcc aic cp"
                onClick={() => advisorCarouselRef.current?.slickNext()}
                aria-label="Next slide"
            >
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.5 5L12.5 10L7.5 15" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </button>
        </div>
    );
};

export default AdvisorCarousel;

